export default __webpack_public_path__ + "static/media/dumpster-fire.47b31316.gif";